import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import heroImage from "../assets/DSC_4598.JPG";
import "./Home.css";

const Home = () => {
  return (
    <main className="home-hero">
      <div className="hero-media">
        <img
          src={heroImage}
          alt="OG Group building"
          className="hero-img"
          loading="eager"
        />
        <div className="hero-overlay">
          <div className="hero-content container">
            <h1 className="hero-title">OG Image Group Photography</h1>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
